<template>
  <b-container class="payment__success">
    <b-card class="px-2 py-2">
      <img
        src="../assets/images/payment_failed.svg"
        width="200"
        height="200"
        alt=""
      />
      <h3 class="text-center text-danger">Payment Failed</h3>
      <p class="text-center">Unfortunately your payment was not successful.</p>
      <hr />
      <table style="width: 400px" v-if="details.length">
        <tr v-for="(td, i) in details" :key="i">
          <td class="py-1">{{ td.label }}</td>
          <td class="py-1">
            <b>{{ td.value }}</b>
          </td>
        </tr>
      </table>
      <hr />
      <b-button variant="primary" @click="goBack">Try Again</b-button>
    </b-card>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      doc: {
        transaction_no: "Transaction No",
        payment_type: "Payment Type",
        error: "Reason",
      },
      paymentTypeMap: {
        "1": "Hospital Registration (ARF)",
        "2": "Hospital Renewal",
        "3": "Organ License (New)",
        "4": "Organ License (Multi)",
        "5": "Organ License (Renewal)",
        "6": "Organ License (Renewal Multi)",
        "7": "Recipient Registration (Single)",
        "8": "Recipient Registration (Multi)",
        "9": "Recipient Transfer (Single)",
        "10": "Recipient Transfer (Multi)",
        "11": "Recipient Transfer (Multi)",
      },
      details: [],
    };
  },
  methods: {
    init() {
      const vm = this;
      const { query } = vm.$route;
      Object.keys(vm.doc).forEach((key) => {
        if (query[key]) {
          let value = query[key];
          if (key === "payment_type") {
            value = vm.paymentTypeMap[value] || value;
          }
          vm.details.push({
            label: vm.doc[key],
            value: value,
          });
        }
      });
    },
    goBack() {
      const vm = this;
      const paymentType = vm.$route.query.payment_type;
      if (paymentType === "1" || paymentType === "2") {
        vm.$router.push("/hospital-registration");
      } else if (
        paymentType === "7" ||
        paymentType === "8" ||
        paymentType === "9" ||
        paymentType === "10" ||
        paymentType === "11"
      ) {
        vm.$router.push("/recipient-registration");
      } else {
        vm.$router.push("/");
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss">
.payment__success {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 100px;
  img {
    margin-bottom: 20px;
  }
}
</style>

